import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'tt-ui-lib/core';
import { ReactComponent as Doc } from '../../../../assets/svg/doc.svg';
import styles from './ResultFilesModal.module.scss';
import CalcUploadedFile from '../CalcUploadedFile/CalcUploadedFile';

const ResultFilesModal = ({ params }) => {
  const { resultsFilesList, resultsFilesCodes, code } = params;
  const [filesModalOpen, setFilesModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [currentResult, setCurrentResult] = useState(null);
  const [disabledBtnNext, setDisabledBtnNext] = useState(true);
  const [disabledBtnPrev, setDisabledBtnPrev] = useState(true);

  const changeIndex = (shift) => {
    const oldIndex = resultsFilesCodes.indexOf(code);
    const newIndex = currentIndex + shift;
    if (currentIndex === null || resultsFilesCodes.length - 1 < newIndex || newIndex < 0) {
      setCurrentIndex(oldIndex);
    } else {
      setCurrentIndex(newIndex);
    }
  };

  useEffect(() => {
    changeIndex(0);
  }, []);

  useEffect(() => {
    const newResult = resultsFilesList.find((q) => q.code === resultsFilesCodes[currentIndex]);
    setCurrentResult(newResult);
    setDisabledBtnNext(resultsFilesCodes.length - 1 < currentIndex + 1);
    setDisabledBtnPrev(currentIndex - 1 < 0);
  }, [currentIndex]);

  const onButtonClick = (value) => {
    setFilesModalOpen(value);
  };

  return (
    <>
      <Button type="default" onClick={() => onButtonClick(true)} startIcon={<Doc />}>
        View docs
      </Button>
      {currentResult && (
        <Modal
          open={filesModalOpen}
          onClose={() => onButtonClick(false)}
          className={styles.filesModal}
          title={currentResult.title}
        >
          <div className={styles.question}>{currentResult.question}</div>
          {currentResult.subquestion && (
            <div className={styles.subquestion}>{currentResult.subquestion}</div>
          )}
          <div className={styles.filesWrapper}>
            <div className={styles.filesContainer}>
              {currentResult?.files?.length &&
                currentResult.files.map((file) => <CalcUploadedFile file={file} />)}
            </div>
          </div>
          <div className={styles.buttonBlock}>
            <Button type="default" onClick={() => changeIndex(-1)} disabled={disabledBtnPrev}>
              Previous
            </Button>
            <Button type="default" onClick={() => changeIndex(1)} disabled={disabledBtnNext}>
              Next
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ResultFilesModal;
